module.exports = __webpack_public_path__ + "img/desktop-hd-boxgraph.7c44f6d1.png";